<nz-list>
  <nz-list-item *ngFor="let animal of animalsDetails$ | async">
    <nz-list-item-meta [nzTitle]="animal.bnpcName | lazyRow:'mobs' | i18n"
                       [nzAvatar]="animal.icon | xivapiIcon"></nz-list-item-meta>
  </nz-list-item>
</nz-list>
